import { Injectable} from '@angular/core';

import { Meta, MetaDefinition } from '../../angular2-meta';

@Injectable()
export class MetaService {

    constructor(private meta: Meta) { 
    }

    setMeta(title, description, keywords){
        this.meta.setTitle(title);
        this.meta.updateMeta('description', description);
        this.meta.updateMeta('keywords', keywords);
    }

    setLanguage(lang){
        this.meta.setLanguage(lang);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/meta.service.ts